export default "__VITE_ASSET__hA_PRJzR__"